import { Observable, switchMap, timer } from "rxjs";

export function pollerTimer<T>(pollIntervalMilliseconds: number) {
  return (source$: Observable<T>) =>
    timer(0, pollIntervalMilliseconds).pipe(
      switchMap(() => source$)
    );
}
